import VisibilitySensor from 'react-visibility-sensor';
import CountUpComp from './CountUp';

const VisibilitySensorComponent = (props: any) => {
  const { end, suffix } = props;
  return (
    <>
      <VisibilitySensor partialVisibility offset={{ bottom: 10, top: 10 }}>
        {({ isVisible }) => (
          <span>
            {isVisible ? <CountUpComp end={end} suffix={suffix} /> : end}
          </span>
        )}
      </VisibilitySensor>
    </>
  );
};

export default VisibilitySensorComponent;
